import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.clients.views.ClientSummaryPicker.';
  public static readonly client = `${Id.prefix}client`;
  public static readonly primaryContact = `${Id.prefix}primaryContact`;
  public static readonly contactEmail = `${Id.prefix}contactEmail`;
  public static readonly address = `${Id.prefix}address`;
}

export class LangClientSummaryPicker {
  private constructor() {}
  public static client(): string {
    return interpolate(Id.client);
  }
  public static primaryContact(): string {
    return interpolate(Id.primaryContact);
  }
  public static contactEmail(): string {
    return interpolate(Id.contactEmail);
  }
  public static address(): string {
    return interpolate(Id.address);
  }
}

export class ClientSummaryPickerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.client, "{{glossary 'client'}}", 'Column header for client name');
    register.add(Id.primaryContact, "Primary {{glossary 'contact'}}", 'Column header for primary contact');
    register.add(Id.contactEmail, "{{glossary 'contact'}} Email", 'Column header for contact email');
    register.add(Id.address, 'Address', 'Column header for address');
  }
}
